module.exports = __webpack_public_path__ + "img/gou.ea157f29.svg";